import React, { useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector, connect } from "react-redux";
import { userActions } from "./../../_actions";
import { Loading } from "../Other/Loading";
import { LoginStaticData } from "../../_constants/staticData";
import { useEffect } from "react";
import "./login.scss";
import TopBar from "../Other/TopBar.js";

function LoginPage(props) {
  const error = useSelector((state) => state.error);
  const { t } = useTranslation();
  const [loginInfo, setLoginInfo] = useState({
    manageForgetPassword: false,
    manageConfirmation: false,
    accountExists: true,
    resendMail: null,
    userName: "",
    password: "",
    managePassword: false,
    fetch: false,
  });

  const [inputError, setInputError] = useState({
    userName: false,
    password: false,
  });

  const history = useHistory();
  const handleViewPassword = () => {
    setLoginInfo({ ...loginInfo, managePassword: !loginInfo.managePassword });
  };

  const getResponse = (data) => {
    if (data.error === false) {
      setLoginInfo({
        ...loginInfo,
        manageConfirmation: !loginInfo.manageConfirmation,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    if (loginInfo.userName === "") {
      setInputError({ userName: true });
    }
    if (loginInfo.password === "") {
      setInputError({ password: true });
    } else {
      if (loginInfo.userName && loginInfo.password) {
        setLoginInfo({ ...loginInfo, fetch: !loginInfo.fetch });
        dispatch(userActions.login(loginInfo.userName, loginInfo.password));
      } else {
        setLoginInfo({ ...loginInfo, fetch: loginInfo.fetch });
      }
    }
  };
  useEffect(() => {
    if (props.loggedIn === true) {
      history.push("/dashboard");
    }
  }, [props.loggedIn]);

  return (
    <>
      <TopBar></TopBar>

      <div>
        <section className="inner_page_breadcrumb"></section>
        <h1 className="centered">Enterprise Login</h1>
      </div>
      <div className="enterprise-form-wrapper">
        <div className="login-form-heading">
          <h3>Login to your account</h3>
        </div>
        <div className="enterprise-login-form">
          <form onSubmit={handleSubmit}>
            <div>
              <input
                placeholder={t("username")}
                aria-label="username"
                type="text"
                className="full"
                onChange={(e) =>
                  setLoginInfo({ ...loginInfo, userName: e.target.value })
                }
              ></input>
            </div>
            <div className="input-error-message">
              {inputError.userName === true && loginInfo.userName.length == 0
                ? "Please enter username !"
                : ""}
            </div>
            <div>
              <input
                placeholder={t("password")}
                aria-label="password"
                type={`${loginInfo.managePassword ? "text" : "password"}`}
                className="full"
                onChange={(e) =>
                  setLoginInfo({ ...loginInfo, password: e.target.value })
                }
              ></input>
              <i
                onClick={handleViewPassword}
                className={`icon ${
                  loginInfo.managePassword
                    ? "icon-view-password-active"
                    : "icon-view-password"
                }`}
              ></i>
            </div>
            <div className="input-error-message">
              {inputError.password === true && loginInfo.password.length == 0
                ? "Please enter Password !"
                : ""}
            </div>

            <div className="class-forget-password">
              <div>
                <Link to="/forget-password" className="reset-password">
                  {t("forgotPassword")}
                </Link>
              </div>
            </div>
            {/* {loginInfo.fetch && error.message === null ? <Loading /> : null} */}
            {/* <p className="text-color">{error.message}</p> */}
            <div className="enterprise-error">
              <p className="text-color">{error.message}</p>
              {loginInfo.fetch && error.message === null ? (
                <div className="enterprise-login-loading">
                  <Loading />
                </div>
              ) : null}
            </div>
            <div>
              <button
                type="submit"
                className="enterprise-login-button"
                role="button"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  return {
    loggedIn,
  };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export default connectedLoginPage;
